/*
 * HdIcons.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-12 in huWaWi3 33.8.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import { Icon as IconifyIcon } from '@iconify/react'
import CloseIcon from '@mui/icons-material/Close'
import DeleteOutlined from '@mui/icons-material/DeleteOutlined'
import EditOutlined from '@mui/icons-material/EditOutlined'
import React from 'react'

export function HdEditIcon(props: any) {
  return <EditOutlined />
}

export function HdAuditIcon(props: any) {
  return <IconifyIcon icon="fluent-mdl2:memo" />
}

export function HdStornoIcon(props: any) {
  return <DeleteOutlined />
}
export function HdRohdatenIcon(props: any) {
  return <IconifyIcon icon="fluent-mdl2:page-data" />
}

export function HdCloseIcon(props: any) {
  return <CloseIcon />
}
